export default "/build/images/1foot.png?53e395de618356b70b868d6b9f606751";